import { useMemo } from "react";
import {
  useParams,
  usePathname,
  useSearchParams,
  type ReadonlyURLSearchParams,
} from "next/navigation";

export function useDashboardPathname(): string {
  return usePathname() ?? "";
}

export function useDashboardSearchParams(): ReadonlyURLSearchParams {
  const searchParams = useSearchParams();
  return useMemo(
    () => searchParams ?? new URLSearchParams(),
    [searchParams],
  ) as ReadonlyURLSearchParams;
}

export function useDashboardParams<
  T extends Record<string, string | string[]> = Record<
    string,
    string | string[]
  >,
>(): T {
  return (useParams<T>() ?? {}) as T;
}
